import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Toggle } from '../components/ui/Toggle';

export default function CookiesPage() {
  const [preferences, setPreferences] = useState({
    necessary: true, // Always enabled
    analytics: true,
    marketing: false,
    personalization: false
  });

  const handleSave = () => {
    // Here you would typically:
    // 1. Save preferences to localStorage
    // 2. Update cookie consent
    // 3. Show success message
    console.log('Saved preferences:', preferences);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-8">Cookie Preferences</h1>
          
          <div className="bg-white rounded-lg shadow-sm p-8 space-y-8">
            <section>
              <h2 className="text-2xl font-semibold mb-4">Cookie Settings</h2>
              <p className="text-gray-600 mb-6">
                We use cookies to enhance your experience on our website. You can choose which cookies you allow us to use.
                Some cookies are necessary for the website to function and cannot be disabled.
              </p>

              <div className="space-y-6">
                {/* Necessary Cookies */}
                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                  <div>
                    <h3 className="font-semibold text-gray-900">Necessary Cookies</h3>
                    <p className="text-sm text-gray-600">
                      Required for the website to function properly. Cannot be disabled.
                    </p>
                  </div>
                  <Toggle
                    checked={preferences.necessary}
                    disabled={true}
                    aria-label="Toggle necessary cookies"
                  />
                </div>

                {/* Analytics Cookies */}
                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                  <div>
                    <h3 className="font-semibold text-gray-900">Analytics Cookies</h3>
                    <p className="text-sm text-gray-600">
                      Help us understand how visitors interact with our website.
                    </p>
                  </div>
                  <Toggle
                    checked={preferences.analytics}
                    onChange={() => setPreferences(prev => ({ ...prev, analytics: !prev.analytics }))}
                    aria-label="Toggle analytics cookies"
                  />
                </div>

                {/* Marketing Cookies */}
                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                  <div>
                    <h3 className="font-semibold text-gray-900">Marketing Cookies</h3>
                    <p className="text-sm text-gray-600">
                      Used to deliver relevant advertisements and track their effectiveness.
                    </p>
                  </div>
                  <Toggle
                    checked={preferences.marketing}
                    onChange={() => setPreferences(prev => ({ ...prev, marketing: !prev.marketing }))}
                    aria-label="Toggle marketing cookies"
                  />
                </div>

                {/* Personalization Cookies */}
                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                  <div>
                    <h3 className="font-semibold text-gray-900">Personalization Cookies</h3>
                    <p className="text-sm text-gray-600">
                      Remember your preferences and provide a tailored experience.
                    </p>
                  </div>
                  <Toggle
                    checked={preferences.personalization}
                    onChange={() => setPreferences(prev => ({ ...prev, personalization: !prev.personalization }))}
                    aria-label="Toggle personalization cookies"
                  />
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">What Are Cookies?</h2>
              <p className="text-gray-600 mb-4">
                Cookies are small text files that are placed on your device when you visit a website. They serve various
                purposes, from ensuring the website functions properly to remembering your preferences and providing
                personalized experiences.
              </p>
            </section>

            <div className="flex justify-end space-x-4">
              <button
                onClick={() => setPreferences({ necessary: true, analytics: false, marketing: false, personalization: false })}
                className="px-4 py-2 text-gray-600 hover:text-gray-900 transition-colors"
              >
                Reject All
              </button>
              <button
                onClick={() => setPreferences({ necessary: true, analytics: true, marketing: true, personalization: true })}
                className="px-4 py-2 text-gray-600 hover:text-gray-900 transition-colors"
              >
                Accept All
              </button>
              <button
                onClick={handleSave}
                className="px-6 py-2 bg-brand-primary text-white rounded-md hover:bg-brand-dark transition-colors"
              >
                Save Preferences
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}